<template>
  <div class="template-connected">
    <div id="container">
      <b-row>
        <b-col cols="12">
          <history-timeline></history-timeline>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import historyTimeline from "../components/historyTimeline.vue";
export default {
  components: {
    "history-timeline": historyTimeline,
  },
};
</script>

<style></style>
